import React, { useEffect, useState } from 'react';

import './ReleasesSelection.scss';
import { useDispatch, useSelector } from 'react-redux';
import { copyDeep, getSafe } from '../../../../shared/utility';
import {
  MODEL_SELECTION_RELEASES,
  MODEL_SELECTION_SELECTED_RELEASE,
} from '../../../../shared/const/Routes/statePaths';
import {
  getModelSelectionReleases,
  setSelectedRelease,
} from '../../../../store/actions/jobConfiguration/jobConfiguration';
import GenericTable from '../../../../components/UI/GenericTable/GenericTable';
import { RELEASE_SELECTION_TABLE } from '../../../../shared/const/GenericTableParams/ReleaseSelection';
import ActionDetails from './ActionDetails';
import { IconButton } from '@mui/material';
import { FileTextOutlined } from '@ant-design/icons';
import LoadingOverlay from '../../../../components/UI/LoadingOverlay/LoadingOverlay';

const ReleasesSelection = props => {
  const { subProject, filters } = props;
  const dispatch = useDispatch();
  const tableData = useSelector(state =>
    getSafe(MODEL_SELECTION_RELEASES, state)
  );

  const [detailsRow, setDetailsRow] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getModelSelectionReleases(subProject, filters));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getModelSelectionReleases(subProject, filters));
  }, [filters]);

  useEffect(() => {
    if (tableData) {
      setIsLoading(false);
    }
  }, [tableData]);

  const getActionContent = () => {
    if (detailsRow) {
      return (
        <ActionDetails rowData={detailsRow} onCancel={handleCloseDetails} />
      );
    }
    return <></>;
  };

  const handleDetailsClick = row => {
    setDetailsRow(row);
  };

  const handleCloseDetails = () => {
    setDetailsRow(null);
  };

  const getRowData = () => {
    let rowData = copyDeep(tableData);
    rowData = rowData.map(row => {
      return {
        ...row,
        details: (
          <>
            <IconButton
              onClick={() => {
                handleDetailsClick(row);
              }}
            >
              <FileTextOutlined />
            </IconButton>
          </>
        ),
      };
    });
    return rowData;
  };

  return (
    <LoadingOverlay loading={isLoading}>
      <div className="release-selection-table-wrapper">
        {tableData ? (
          <GenericTable
            rows={getRowData()}
            columns={RELEASE_SELECTION_TABLE.columns}
            filteringStateColumnExtensions={
              RELEASE_SELECTION_TABLE.filteringStateColumnExtensions
            }
            tableColumnExtensions={
              RELEASE_SELECTION_TABLE.tableColumnExtensions
            }
            filteringEnabled={true}
            tableKey={RELEASE_SELECTION_TABLE.tableKey}
            getActionContent={getActionContent}
            pagingEnabled={false}
            selectedRowStatePath={MODEL_SELECTION_SELECTED_RELEASE}
            setSelectedRow={setSelectedRelease}
          />
        ) : null}
      </div>
    </LoadingOverlay>
  );
};

export default ReleasesSelection;
